export const SEGMENTED_TRACK_CLASS = 'rounded-xl bg-brand-link p-1 ring-1 ring-brand-link';

export const SEGMENT_BASE_CLASS =
  'rounded-lg font-medium outline-none transition-[color,background-color,box-shadow] focus-visible:ring-2 focus-visible:ring-white/70 motion-reduce:transition-none';

export const SEGMENT_ACTIVE_CLASS =
  'bg-card text-brand-link shadow-[0_4px_12px_-6px_color-mix(in_oklab,var(--color-brand-link)_80%,transparent)]';

export const SEGMENT_INACTIVE_CLASS = 'text-white/80 hover:bg-white/10 hover:text-white';
